<div class="ui-theme-settings">
  <button
    type="button"
    placement="left"
    ngbTooltip="Open Layout Configurator"
    class="btn-open-options btn btn-warning"
    (click)="toggleOptionsDrawer()"
  >
    <!-- <fa size="3x" name="cog" animation="spin"></fa> -->
    <i class="fa fa-cog fa-3x" animation="spin" aria-hidden="true"></i>
  </button>
  <div class="theme-settings__inner">
    <div class="scrollbar-container">
      <perfect-scrollbar [autoPropagation]="true">
        <div class="theme-settings__options-wrapper">
          <h3 class="themeoptions-heading">Layout Options</h3>
          <div class="p-3">
            <ul class="list-group">
              <li class="list-group-item">
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left mr-3">
                      <mat-checkbox
                        (change)="toggleFixedFooter()"
                      ></mat-checkbox>
                    </div>
                    <div class="widget-content-left">
                      <div class="widget-heading">Fixed Footer</div>
                      <div class="widget-subheading">
                        Makes the app footer bottom fixed, always visible!
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <h3 class="themeoptions-heading">
            <div>Header Options</div>
            <button
              type="button"
              (click)="updateConfig({ sidebarTheme: '', headerTheme: '' })"
              class="btn-pill btn-shadow btn-wide ml-auto btn btn-focus btn-sm"
            >
              Restore Default
            </button>
          </h3>
          <div class="p-3">
            <ul class="list-group">
              <li class="list-group-item">
                <h5 class="pb-2">Choose Color Scheme</h5>
                <div class="theme-settings-swatches">
                  <div
                    class="swatch-holder bg-primary"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-primary text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-secondary"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-secondary text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-success"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-success text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-info"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-info text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-warning"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-warning text-darker'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-danger"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-danger text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-light"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-light text-darker'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-dark"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-dark text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-focus"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-focus text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-alternate"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-alternate text-lighter'
                      })
                    "
                  ></div>
                  <div class="divider"></div>
                  <div
                    class="swatch-holder bg-vicious-stance"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-vicious-stance text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-midnight-bloom"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-midnight-bloom text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-night-sky"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-night-sky text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-slick-carbon"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-slick-carbon text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-asteroid"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-asteroid text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-royal"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-royal text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-warm-flame"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-warm-flame text-darker'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-night-fade"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-night-fade text-darker'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-sunny-morning"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-sunny-morning text-darker'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-tempting-azure"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-tempting-azure text-darker'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-amy-crisp"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-amy-crisp text-darker'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-heavy-rain"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-heavy-rain text-darker'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-mean-fruit"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-mean-fruit text-darker'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-malibu-beach"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-malibu-beach text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-deep-blue"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-deep-blue text-darker'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-ripe-malin"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-ripe-malin text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-arielle-smile"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-arielle-smile text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-plum-plate"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-plum-plate text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-happy-fisher"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-happy-fisher text-darker'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-happy-itmeo"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-happy-itmeo text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-mixed-hopes"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-mixed-hopes text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-strong-bliss"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-strong-bliss text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-grow-early"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-grow-early text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-love-kiss"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-love-kiss text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-premium-dark"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-premium-dark text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-happy-green"
                    (click)="
                      updateConfig({
                        sidebarTheme: '',
                        headerTheme: 'bg-happy-green text-lighter'
                      })
                    "
                  ></div>
                </div>
              </li>
            </ul>
          </div>
          <h3 class="themeoptions-heading">
            <div>Sidebar Options</div>
            <button
              type="button"
              (click)="updateConfig({ sidebarTheme: '' })"
              class="btn-pill btn-shadow btn-wide ml-auto btn btn-focus btn-sm switch-sidebar-cs-class"
            >
              Restore Default
            </button>
          </h3>
          <div class="p-3">
            <ul class="list-group">
              <li class="list-group-item">
                <h5 class="pb-2">Choose Color Scheme</h5>
                <div class="theme-settings-swatches">
                  <div
                    class="swatch-holder bg-primary"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-primary text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-secondary"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-secondary text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-success"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-success text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-info"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-info text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-warning"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-warning text-darker'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-danger"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-danger text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-light"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-light text-darker'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-dark"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-dark text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-focus"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-focus text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-alternate"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-alternate text-lighter'
                      })
                    "
                  ></div>
                  <div class="divider"></div>
                  <div
                    class="swatch-holder bg-vicious-stance"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-vicious-stance text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-midnight-bloom"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-midnight-bloom text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-night-sky"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-night-sky text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-slick-carbon"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-slick-carbon text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-asteroid"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-asteroid text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-royal"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-royal text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-warm-flame"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-warm-flame text-darker'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-night-fade"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-night-fade text-darker'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-sunny-morning"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-sunny-morning text-darker'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-tempting-azure"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-tempting-azure text-darker'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-amy-crisp"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-amy-crisp text-darker'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-heavy-rain"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-heavy-rain text-darker'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-mean-fruit"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-mean-fruit text-darker'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-malibu-beach"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-malibu-beach text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-deep-blue"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-deep-blue text-darker'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-ripe-malin"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-ripe-malin text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-arielle-smile"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-arielle-smile text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-plum-plate"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-plum-plate text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-happy-fisher"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-happy-fisher text-darker'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-happy-itmeo"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-happy-itmeo text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-mixed-hopes"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-mixed-hopes text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-strong-bliss"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-strong-bliss text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-grow-early"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-grow-early text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-love-kiss"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-love-kiss text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-premium-dark"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-premium-dark text-lighter'
                      })
                    "
                  ></div>
                  <div
                    class="swatch-holder bg-happy-green"
                    (click)="
                      updateConfig({
                        headerTheme: '',
                        sidebarTheme: 'bg-happy-green text-lighter'
                      })
                    "
                  ></div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </perfect-scrollbar>
    </div>
  </div>
</div>
